export default __webpack_public_path__ + "static/media/subimage.b628f533.jpg";